import { AICOPY_USDC_CODE, isAicopyUsdc, isAicopyUsdt, parseAicopyBalanceNum } from "./aicopyCurrencies";
import { AICOPY_ORDER_OPTION_VOUCHER, isAicopyVoucherOrderOption } from "./aicopyOrderOptions";

export function hasPositiveAicopyBalance(balanceStr) {
  return parseAicopyBalanceNum(balanceStr) > 0;
}

function normalizeFiatCodes(fiatOptions = [], primaryFiat = null) {
  const fiats = (fiatOptions || []).map((c) => String(c || "").toUpperCase()).filter(Boolean);
  const ordered = [];
  const primary = primaryFiat != null ? String(primaryFiat).toUpperCase() : "";
  if (primary && primary !== "USDT" && fiats.includes(primary)) {
    ordered.push(primary);
  }
  fiats.forEach((code) => {
    if (!ordered.includes(code)) ordered.push(code);
  });
  return ordered;
}

/**
 * 默认下单币种：有可用券 > 法币有余额 > USDT有余额 > USDC有余额 > 法币为0(命中) > USDT
 */
export function resolveAicopyDefaultPayCurrency({
  hasUsableVouchers = false,
  fiatOptions = [],
  fiatBalanceMap = {},
  usdtBalance = "0",
  usdcBalance = "0",
  primaryFiat = null,
} = {}) {
  if (hasUsableVouchers) return AICOPY_ORDER_OPTION_VOUCHER;

  const orderedFiats = normalizeFiatCodes(fiatOptions, primaryFiat);

  for (const code of orderedFiats) {
    if (hasPositiveAicopyBalance(fiatBalanceMap?.[code])) return code;
  }
  if (hasPositiveAicopyBalance(usdtBalance)) return "USDT";
  if (hasPositiveAicopyBalance(usdcBalance)) return AICOPY_USDC_CODE;
  if (orderedFiats.length) return orderedFiats[0];
  return "USDT";
}

/**
 * 多资产展示/排序优先级（数值越小越靠前）
 * 法币有余额 > USDT有余额 > USDC有余额 > 法币为0(命中) > USDT > USDC > 用券
 */
export function getAicopyPayCurrencyPriority(code, ctx = {}) {
  const {
    fiatOptions = [],
    fiatBalanceMap = {},
    usdtBalance = "0",
    usdcBalance = "0",
    hasUsableVouchers = false,
  } = ctx;

  if (isAicopyVoucherOrderOption(code)) {
    return hasUsableVouchers ? 0 : 20;
  }

  const upper = String(code || "").toUpperCase();
  const fiatSet = new Set((fiatOptions || []).map((c) => String(c).toUpperCase()));
  const isFiat = fiatSet.has(upper);

  if (isFiat && hasPositiveAicopyBalance(fiatBalanceMap?.[upper])) return 1;
  if (isAicopyUsdt(upper) && hasPositiveAicopyBalance(usdtBalance)) return 2;
  if (isAicopyUsdc(upper) && hasPositiveAicopyBalance(usdcBalance)) return 3;
  if (isFiat) return 4;
  if (isAicopyUsdt(upper)) return 5;
  if (isAicopyUsdc(upper)) return 6;
  return 99;
}

/** 币种下拉按资产优先级排序（用券有券时排最前） */
export function sortAicopyOrderCurrencyOptions(options, ctx = {}) {
  const list = Array.isArray(options) ? options : [];
  return [...list].sort((a, b) => {
    const pa = getAicopyPayCurrencyPriority(a, ctx);
    const pb = getAicopyPayCurrencyPriority(b, ctx);
    if (pa !== pb) return pa - pb;
    return String(a).localeCompare(String(b));
  });
}

/** 多资产时优先展示余额的币种（不含用券） */
export function resolveAicopyPreferredBalanceCurrency(ctx = {}) {
  return resolveAicopyDefaultPayCurrency({ ...ctx, hasUsableVouchers: false });
}
